module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/bravesmash.dab7215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/bravesmash.jpg
// module id = QtiV
// module chunks = 0